import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { KundeSummary } from './KundeSummary';

export const KundeSummaryPrint: React.FC = () => {
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);

    const kNr = urlSearchParams.get('kNr') ? parseInt(urlSearchParams.get('kNr') || '0', 10) : 0;

    return <KundeSummary kNr={kNr} printView />;
};
